module.exports = __webpack_public_path__ + "img/Pencil2.ca70c02a.svg";